import { Box, } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
    List,
    Datagrid,
    TextField,
    TextInput,
    SelectInput,
    TopToolbar,
    EditButton,
    DeleteButton,
    DateField,
    FunctionField,
    useDataProvider,
    CreateButton,
    Pagination,
    useListContext,
    Button
} from "react-admin";


const ListActions = () => {
    const { setFilters, filterValues } = useListContext();  // 获取列表上下文
    const initialFilters = {};  // 初始过滤器值

    // 重置过滤器函数
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    return (
        <TopToolbar>
            <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}  // 当没有过滤条件时禁用
            />
            <CreateButton />
        </TopToolbar>
    );
};

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 20, 30]} />;


export const upgradeSystemList = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [deviceTypes, setDeviceTypes] = useState([]);
    const hasFetched = useRef(false); // 添加 useRef 标记

    useEffect(() => {
        if (hasFetched.current) {
            return;
        }
        const token = localStorage.getItem("authToken");
        if (!token) {
            return; // 如果没有 token，则不请求
        }
        hasFetched.current = true; // 标记已请求

        const fetchDeviceTypes = async () => {
            try {
                const deviceListResponse = await dataProvider.getDeviceList()

                const deviceTypesData = Array.isArray(deviceListResponse)
                    ? deviceListResponse
                    : deviceListResponse?.data || [];

                const types = deviceTypesData.map((item) => ({
                    id: item.name,
                    name: item.name
                }));

                setDeviceTypes(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchDeviceTypes();
    }, []);

    let postFilters = [
        <TextInput
            alwaysOn
            key="title"
            source="title"
            label="标题"
        />,
        <SelectInput
            alwaysOn
            key="otaType"
            source="otaType"
            label="OTA包类型"
            choices={[
                {
                    id: 'FIRMWARE',
                    name: '固件(设备端的系统软件)',
                },
                {
                    id: 'SOFTWARE',
                    name: '软件(包含云商程序的软件包)',
                }
            ]}
        />,
        <SelectInput
            alwaysOn
            key="deviceType"
            source="deviceType"
            label="设备类型"
            choices={deviceTypes}
        />
    ];

    return (
        <List filters={postFilters} actions={<ListActions />} empty={false} pagination={<PostPagination />}
        >
            <Datagrid bulkActionButtons={false} rowClick={false}>
                {/* <TextField source="id" label="序号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/> */}
                <TextField source="title" label="文件标题" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <FunctionField
                    label="OTA类型"
                    render={(record) => {
                        return <Box>{record.otaType == 'FIRMWARE' ? '固件' : '软件'}</Box>;
                    }}
                    sortable={false}
                />
                <TextField source="version" label="OTA镜像版本" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceType" label="设备类型" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <DateField source="createdTime" label="上传日期" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="description" label="OTA描述" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <FunctionField
                    label="操作"
                    render={(record) => (
                        <Box sx={{ justifyContent: 'center', display: 'flex', gap: '8px' }}>
                            <EditButton />
                            {/* <DeleteButton mutationMode="pessimistic" confirmTitle={`确认删除OTA镜像版本${record.version}`}/> */}
                        </Box>
                    )}
                />
            </Datagrid>
        </List>
    )
}